<template>
	<div class="select-model">
        <div class="form-group row">
            <div :class="{'col-md-3': !labelAbove, 'col-12': labelAbove}">
                <label :class="labelClass != undefined ? labelClass : 'form-title'">{{label}}</label>
            </div>

            <div class="position-relative" :class="{'col-md-9': !labelAbove, 'col-12': labelAbove}">
                <div class="d-flex justify-content-center align-items-center position-absolute w-100 h-100" v-if="preselecting">
					<loader></loader>
                </div>
                <div v-if="!model_selected">
                    <input type="text" class="form-control" :placeholder="label" v-model="model_edit.name" v-bind:class="hasError(model_name + '.name') ? 'is-invalid' : ''">
                    <!-- <span v-if="hasError(model_name + '.name')" class="invalid-feedback" role="alert">{{ errors[model_name + '.name'].join(' ') }}</span> -->
                    <div v-if="loading" class="position-absolute" style="top: 3px; right: 18px;">
						<loader></loader>
                    </div>
                    <div class="w-100 position-relative">
                        <div v-if="model_edit.name" class="select-model--dropdown">
                            <div v-if="!onlySelect || loading">
                                <div v-if="!loading && !debounce_timer">
                                    <a href="javascript:void(0)" v-on:click="select(null)">Create {{model_edit.name}}</a>
                                </div>
                                <div v-else>Loading...</div>
                            </div>

                            <div :class="!onlySelect ? 'mt-3' : ''" v-for="(record, index) in models_found">
                                <a href="javascript:void(0)" v-on:click="select(index)">{{record.name}}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="form-control d-flex justify-content-between">
                        <span>{{model_edit.name}}</span>
                        <button class="rounded rounded-circle" v-on:click="unselect()">X</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="model_selected && !model_edit.id && !preselecting && !disableCreate" v-for="data in model_template" class="form-group row">
            <div class="col-md-3">
                <label>{{data.label}}</label>
            </div>
            <div class="col-md-9">
                <input type="text" class="form-control" v-model="model_edit[data.prop]" v-bind:class="hasError(model_name + '.' + data.prop) ? 'is-invalid' : ''">
                <!-- <span v-if="hasError(model_name + '.' + data.prop)" class="invalid-feedback" role="alert">{{ errors[model_name + '.' + data.prop].join(' ') }}</span> -->
            </div>
        </div>
    </div>
</template>

<script>
	import Loader from "./Loader";
	export default {
		name: "SearchOrCreateModel",
		components: {Loader},
		props: [
            'value',
            'model_template',
            'search_url',
            'label',

            'errors',
            'model_name',

            'selected',

            'labelAbove',

            'disableCreate',
            'onlySelect',

            'labelClass'
        ],

        data(){
			return {
				model_edit: {},
                models_found: [],

                model_selected: false,

                debounce_timer: null,
				loading: false,
                reload: false,

                preselecting: false
            }
        },

        beforeMount() {
			this.model_selected = this.selected;

			if(this.model_selected){
			    this.preselecting = true;

			    this.model_edit.name = '';
                this.search()
                    .then(select => {
                        if(select){
                            this.select(this.model_selected);
                        }

                        this.preselecting = false;
                    })
            }
		},

        methods: {
			hasError(key){
				return !!this.errors[key];
			},

			search(){
                let _this = this;
                return new Promise((resolve, reject) => {

                    if (_this.loading){
                        resolve(false);

                        _this.reload = true;
                        return;
                    }

                    clearTimeout(_this.debounce_timer);
                    _this.debounce_timer = null;
                    _this.loading = true;
                    let url = _this.search_url;
                    url = url.indexOf('?') !== -1 ? url + '&search=' + encodeURI(_this.model_edit.name) : url + '?search=' + encodeURI(_this.model_edit.name);

                    axios.get(url)
                        .then(function (response){
                            _this.loading = false;
                            if (_this.reload){
                                _this.reload = false;
                                _this.search();
                            }

                            _this.models_found = response.data;

                            resolve(true);
                        })
                        .catch(function (error){
                            reject(error);
                        })
                })
            },

            select(model_index){
				if (model_index != null){
					this.model_edit = this.models_found[model_index];
                } else {
                    this.$delete(this.model_edit, 'id');
                }

				this.$emit('select_model', this.model_edit);
            },

			unselect(){
				this.model_edit = {};
				this.$emit('unselect_model', this.model_edit);
            }
        },

        watch: {
			model_edit: {
				deep: true,
				handler: function (){
					this.$emit('input', this.model_edit);
                }
            },

			'model_edit.name': function (){
				let _this = this;
				if (_this.debounce_timer)clearTimeout(_this.debounce_timer);
				_this.debounce_timer = setTimeout(_this.search, 300);
				_this.models_found = [];
            },

            selected (){
				this.model_selected = this.selected;
            }
        }
	}
</script>
